import { render } from "./PurchaseProofs.vue?vue&type=template&id=7abc4c6e&scoped=true"
import script from "./PurchaseProofs.vue?vue&type=script&lang=js"
export * from "./PurchaseProofs.vue?vue&type=script&lang=js"

import "./PurchaseProofs.vue?vue&type=style&index=0&id=7abc4c6e&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abc4c6e"]])

export default __exports__